import _ from 'lodash';
import axios from 'axios';
import URLS from '../config/urls';
import Soap from '../ews/soap';

const validateEmail = (email) => {
    // eslint-disable-next-line
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};

export default {

    async getSTContacts () {
        let result;
        // eslint-disable-next-line
        await axios.get(URLS.contacts)
            .then(response => {
                result = response;
            })
            .catch(error => {
                result = [];
            });
        return result;
    },
    async getOutlookContacts (callback) {
        const mailbox = window.Office.context.mailbox;
        mailbox.makeEwsRequestAsync(
            Soap.getOutlookContacts(), (response) => {
                callback(response);
            });
    },
    async createContacts (contacts, callback) {
        const mailbox = window.Office.context.mailbox;
        const callEWS = (newContacts, callbackFunction) => {
            if (contacts.length === 0) {
                callbackFunction();
                return;
            }
            mailbox.makeEwsRequestAsync(Soap.createNewContactXML(newContacts.pop()), (response) => {
                if (response.status !== 'succeeded') {
                    // eslint-disable-line
                }
                return callEWS(newContacts, callbackFunction);
            });
        };
        return callEWS(contacts, callback);
    },
    filterContacts (STContacts, outlookEmails) {
        const newContacts = [];
        _.forEach(STContacts, (stContact) => {
            if (stContact.person.contact.email !== '' && validateEmail(stContact.person.contact.email)) {
                let shouldBeAdded = true;
                _.forEach(outlookEmails, (outlookEmail) => {
                    if (stContact.person.contact.email === outlookEmail) {
                        shouldBeAdded = false;
                    }
                });
                if (shouldBeAdded) {
                    newContacts.push(stContact);
                }
            }
        });
        return newContacts;
    },
    getEmailsFromEWSXML (xml) {
        const parser = new DOMParser();
        const responseDoc = parser.parseFromString(xml, 'text/xml');
        return responseDoc.getElementsByTagName('t:EmailAddresses');
    }
};



// WEBPACK FOOTER //
// ./src/services/ContactsService.js